module.exports = __webpack_public_path__ + "static/img/2s-design-b1.0c68cc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/2s-design-b1.jpg
// module id = q6H2
// module chunks = 0